import { isSameId } from "../../helpers";
export default function (store, ev) {
    const id = ev.id;
    if (!store.existsProject(id))
        return;
    const state = store.getState();
    if (!ev.$meta) {
        ev.$meta = {};
    }
    ev.$meta.branchId = "$allBranches";
    let nextActive = null;
    let originalProject;
    const projects = state.projects.filter((project, index) => {
        const found = isSameId(project.id, id);
        if (found) {
            originalProject = { ...project };
            if (index > 0) {
                nextActive = state.projects[index - 1].id;
            }
            else {
                nextActive = state.projects[index + 1]?.id || null;
            }
        }
        return !found;
    });
    const kids = [];
    state.tasks.forEach(task => {
        if (isSameId(task.project, id)) {
            kids.push(task);
            store.in.exec("update-task", {
                id: task.id,
                task: {
                    ...task,
                    project: null,
                },
                skipProvider: true,
                skipStateCalc: true,
                $meta: {
                    skipHistory: true,
                },
            });
        }
        return task;
    });
    const tasks = state.tasks;
    const { treeTasks, childrenMap, filteredChildrenMap } = store.getInnerState(tasks, state.activeProject);
    store.setState({
        projects,
        treeTasks,
        tasks,
        childrenMap,
        filteredChildrenMap,
    });
    if (isSameId(state.activeProject, id)) {
        store.in.exec("set-project", {
            id: nextActive,
        });
    }
    return () => {
        store.in.exec("add-project", {
            id: originalProject.id,
            project: originalProject,
            $meta: {
                skipHistory: true,
                restore: id,
            },
        });
        for (let i = 0; i < kids.length; i++) {
            if (i === 0) {
                store.in.exec("update-task", {
                    id: kids[i].id,
                    task: kids[i],
                    batch: kids.slice(1),
                    $meta: {
                        skipHistory: true,
                    },
                });
            }
            else {
                store.in.exec("update-task", {
                    id: kids[i].id,
                    task: kids[i],
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
            }
        }
        store.in.exec("set-project", { id: originalProject.id });
    };
}
//# sourceMappingURL=delete.js.map